import AlphabetKeyboard from './AlphabetKeyboard';
import HorizontalNumericKeyboard from './HorizontalNumericKeyboard';
import NumericKeyboard from './NumericKeyboard';
import SimpleKeyboard, { KeyboardAppearanceType } from './SimpleKeyboard';
import { KeyItemProps } from './helpers/keyboardItems';

type TvKeyboardProps = {
  variant?: string;
  appearance?: KeyboardAppearanceType;
  textValue: string;
  setTextValue: (newText: string) => void;
};

const TvKeyboard: React.FC<TvKeyboardProps> = ({
  variant = 'default',
  appearance = 'default',
  textValue,
  setTextValue,
}) => {
  const onHandleKeyPress = (keyItem: KeyItemProps) => {
    switch (keyItem.item) {
      case 'backspace':
        if (textValue.length > 0) {
          setTextValue(textValue.slice(0, -1));
        }
        break;
      case 'clear':
        setTextValue('');
        break;
      case 'space':
      default:
        if (keyItem.value !== null) {
          setTextValue(textValue + keyItem.value);
        }
        break;
    }
  };

  switch (variant) {
    case 'alphabet':
      return <AlphabetKeyboard onHandleKeyPress={onHandleKeyPress} appearance={appearance} />;
    case 'numeric':
      return <NumericKeyboard onHandleKeyPress={onHandleKeyPress} appearance={appearance} />;
    case 'horizontal-numeric':
      return (
        <HorizontalNumericKeyboard onHandleKeyPress={onHandleKeyPress} appearance={appearance} />
      );
    case 'simple':
    default:
      return <SimpleKeyboard onHandleKeyPress={onHandleKeyPress} appearance={appearance} />;
  }
};

export default TvKeyboard;
